module.exports = __webpack_public_path__ + "img/arty4.4236c508.png";